// Full Multi-Step Form for Creating Doctor Profile
import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  FormFeedback,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Select from "react-select";
import Switch from "react-switch";
import ReactQuill from "react-quill";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";
import PhoneInput from "react-phone-number-input";
import SweetAlert from "react-bootstrap-sweetalert";
import { CreateDoctorProfile } from "services/V2_APIs/DoctorsConsultationApis/doctorsInfo.service";
import getImageUrl from "utils/getImageUrl";
import Spinner from "components/spinner";
import ProfileImage from "components/profileImage";
import languagesList from "utils/languagesList";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import getImage from "utils/getImage";
const modules = {
  toolbar: {
    container: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      ["link", "image"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ indent: "-1" }, { indent: "+1" }],
      ["clean"],
    ],
    handlers: {
      // Ensures editor stays focused after clicking toolbar buttons
      bold: function () {
        this.quill.format("bold", !this.quill.getFormat().bold);
        this.quill.focus();
      },
      italic: function () {
        this.quill.format("italic", !this.quill.getFormat().italic);
        this.quill.focus();
      },
      underline: function () {
        this.quill.format("underline", !this.quill.getFormat().underline);
        this.quill.focus();
      },
      // ... Add more handlers as needed
    },
  },
};
const CreateDoctor = ({ toggle, modal, reload }) => {
  const quillRef = useRef(null);
  const [step, setStep] = useState(1);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [ProfileImg, setProfileImg] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [regNo, setRegNo] = useState("");
  const [prefix, setPrefix] = useState("Dr");
  // console.log(prefix, "pre");
  const [loading, setLoading] = useState(false);
  const [isLicensed, setIsLicensed] = useState(false);
  const [languages, setLanguages] = useState([]);
  const statusList = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const genderList = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
  ];

  const initialValues = {
    regNo: "",
    fullName: "",
    shortName: "",
    email: "",
    mobileNumber: "",
    gender: "",
    birthYear: "",
    specialization: [],
    qualification: [],
    practicingSince: "",
    experience: "",
    languages: [],
    licenseNumber: "",
    consultationFee: "",
    status: "",
    profileImage: "",
    isLicensed: false,
    title: "",
    aboutMe: "",
  };
  const specializationOptions = [
    { label: "Dermatologist", value: "Dermatologist" },
    { label: "Cosmetologist", value: "Cosmetologist" },
    { label: "Aesthetic Physician", value: "Aesthetic Physician" },
    { label: "Dermatosurgeon", value: "Dermatosurgeon" },
    { label: "Pediatric Dermatologist", value: "Pediatric Dermatologist" },
    {
      label: "Trichologist(Skin-focused)",
      value: "Trichologist(Skin-focused)",
    },
    { label: "Hair Transplant Surgeon", value: "Hair Transplant Surgeon" },
    { label: "Cosmetic Surgeon", value: "Cosmetic Surgeon" },
  ];
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const validationSchema = Yup.object().shape({
    fullName:
      step === 1 ? Yup.string().required("Enter Full Name") : Yup.string(),
    shortName:
      step === 1 ? Yup.string().required("Enter Short Name") : Yup.string(),
    email:
      step === 1 ? Yup.string().email().required("Enter Email") : Yup.string(),
    mobileNumber:
      step === 1 ? Yup.string().required("Enter Mobile Number") : Yup.string(),
    gender: step === 1 ? Yup.string().required("Select Gender") : Yup.string(),
    // licenseNumber:
    //   step === 2 ? Yup.string().required("Enter License Number") : Yup.string(),
    consultationFee:
      step === 2 ? Yup.string().required("Enter Fee") : Yup.string(),
    status: step === 3 ? Yup.string().required("Select Status") : Yup.string(),
  });

  const generateRandomCode = () => {
    const uniqueNumber = Math.floor(100000 + Math.random() * 900000);
    setRegNo(uniqueNumber.toString());
  };
  useEffect(() => {
    let languages = [];
    languagesList?.map(ele => {
      let obj = {
        value: ele?.name,
        label: ele?.name,
      };
      languages.push(obj);
    });
    setLanguages(languages);
  }, []);
  const handleSwitch = event => {
    setIsLicensed(event);
  };
  const onSubmit = async values => {
    setLoading(true);
    const payload = {
      ...values,
      regNo,
      isLicensed: isLicensed,
      fullName: `${prefix} ${values?.fullName}`,
      profileImage: ProfileImg,
      status: selectedStatus?.value,
      qualification: values?.qualification
        .split(",")
        .map(s => s.trim())
        .filter(s => s),
        mobileNumber : values?.mobileNumber.replace(/^\+91/, ""),
    };
    console.log(payload, "paylod");
    try {
      const res = await CreateDoctorProfile(payload);
      setLoading(false);
      if (res?.success) {
        setsuccess_msg(true);
        reload();
      } else {
        seterror_msg(true);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      seterror_msg(true);
    }
  };
  const onCancel = () => {
    setStep(1);
  };
  return (
    <>
      <Spinner loading={loading} />
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        size="lg"
        onClosed={() => {
          onCancel();
        }}
      >
        <ModalHeader toggle={toggle}>
          <h5 className="mb-3">
            {step === 1 && "Basic Information"}
            {step === 2 && "Professional Details"}
            {step === 3 && "Profile Info"}
          </h5>
        </ModalHeader>
        <ModalBody>
          <Container>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ values, handleChange, setFieldValue, errors, touched }) => (
                <Form>
                  <Row>
                    {step === 1 && (
                      <>
                        <Col md={4} className="mb-3">
                          <Label
                            for="regNo"
                            className="d-flex justify-content-between"
                          >
                            <div>
                              Registration Number{" "}
                              <span className="text-danger">*</span>
                            </div>

                            {!regNo ? (
                              <Button
                                className=" border border-0 p-0 px-2 text-info "
                                color="light"
                                role="button"
                                onClick={() => generateRandomCode()}
                              >
                                Generate
                              </Button>
                            ) : (
                              ""
                            )}
                          </Label>

                          <Input
                            type="text"
                            name="regNo"
                            id="regNo"
                            placeholder="regNo"
                            value={regNo}
                            disabled={true}
                          />
                        </Col>
                        <Col md={5} className="mb-3">
                          <Label>
                            Full Name <span className="text-danger">*</span>
                          </Label>
                          <div className="d-flex">
                            <select
                              className="form-select me-2"
                              name="prefix"
                              value={prefix}
                              onChange={e => setPrefix(e.target.value)}
                              style={{ width: "30%" }}
                            >
                              <option value="Mr.">Mr.</option>
                              <option value="Mrs.">Mrs.</option>
                              <option value="Miss">Miss</option>
                              <option value="Dr.">Dr.</option>
                            </select>

                            <Input
                              name="fullName"
                              value={values.fullName}
                              onChange={e =>
                                setFieldValue("fullName", e.target.value)
                              }
                              invalid={touched.fullName && !!errors.fullName}
                            />
                          </div>
                        </Col>

                        <Col md={4} className="mb-3">
                          <Label>
                            Short Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="shortName"
                            value={values.shortName}
                            onChange={handleChange}
                            invalid={touched.shortName && !!errors.shortName}
                          />
                        </Col>
                        <Col md={4} className="mb-3">
                          <Label>
                            Email <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            invalid={touched.email && !!errors.email}
                          />
                        </Col>
                        <Col md={4} className="mb-3">
                          <Label>
                            Mobile Number <span className="text-danger">*</span>
                          </Label>
                          <PhoneInput
                            className="custom_country_phoneNumber"
                            defaultCountry="IN"
                            value={values.mobileNumber}
                            onChange={value => {
                              // Remove the +91 prefix if present
                              // const numberWithoutCountryCode = value?.replace(
                              //   /^\+91/,
                              //   ""
                              // );
                              setFieldValue(
                                "mobileNumber",
                                value
                              );
                            }}
                          />
                        </Col>

                        <Col md={4}>
                          <Label>
                            Gender <span className="text-danger">*</span>
                          </Label>
                          <Select
                            options={genderList}
                            onChange={opt => {
                              setFieldValue("gender", opt.value);
                              setSelectedType(opt);
                            }}
                            value={selectedType}
                          />
                        </Col>
                        <Col md={4}>
                          <Label>Birth Year </Label>
                          <Input
                            type="date"
                            name="birthYear"
                            value={values.birthYear}
                            onChange={handleChange}
                            max={new Date().toISOString().split("T")[0]} // Prevent future dates
                          />
                        </Col>
                        <Col md={12} className="mt-3">
                          <Label>About Me</Label>
                          {/* <CKEditor
                            editor={ClassicEditor}
                            data={values.experience}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFieldValue("experience", data); // If you're using Formik
                            }}
                          /> */}
                          <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            value={values?.aboutMe}
                            onChange={value => {
                              setFieldValue("aboutMe", value);
                            }}
                            modules={modules}
                          />
                        </Col>
                      </>
                    )}

                    {step === 2 && (
                      <>
                        <Col md={6} className="mb-3">
                          <Label>Professional title </Label>
                          <Input
                            name="title"
                            value={values.title}
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={6} className="mb-3">
                          <Label>Specializations</Label>
                          <Select
                            isMulti
                            name="specialization"
                            options={specializationOptions}
                            value={specializationOptions.filter(opt =>
                              values.specialization?.includes(opt.value)
                            )}
                            onChange={selected =>
                              setFieldValue(
                                "specialization",
                                selected.map(opt => opt.value)
                              )
                            }
                            placeholder="Select specializations"
                          />
                        </Col>
                        <Col md={6} className="mb-3">
                          <Label>Qualifications</Label>
                          <Input
                            name="qualification"
                            placeholder="Enter qualifications"
                            value={values.qualification}
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={3} className="mb-3">
                          <Label>Practicing Since</Label>
                          <Input
                            name="practicingSince"
                            value={values.practicingSince}
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={3} className="mb-3">
                          <Label>Experience</Label>
                          <Input
                            name="experience"
                            value={values.experience}
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={4} className="mb-3">
                          <Label>
                            Consultation Fee{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="consultationFee"
                            value={values.consultationFee}
                            onChange={handleChange}
                          />
                        </Col>
                        <Col md={6} className="mb-3">
                          <Label>Languages</Label>
                          <Select
                            isMulti
                            options={languages}
                            onChange={opt =>
                              setFieldValue(
                                "languages",
                                opt.map(o => o.value)
                              )
                            }
                          />
                        </Col>
                        <Col md={12}>
                          {/* <Label>Is Licensed?</Label>
                          <Input
                            type="checkbox"
                            name="isLicensed"
                            className="ms-3"
                            checked={values.isLicensed}
                            onChange={e =>
                              setFieldValue("isLicensed", e.target.checked)
                            } // ✅ force boolean toggle
                          /> */}
                          <div className="d-flex align-items-center flex-wrap mt-4">
                            <Switch
                              onChange={event => handleSwitch(event)}
                              checked={isLicensed}
                              onColor="#86d3ff"
                              onHandleColor="#2693e6"
                              handleDiameter={25}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              // boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                              // activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={15}
                              width={40}
                              className="react-switch"
                              id="material-switch"
                            />
                            <div>
                              <h6 className="mb-0 ms-2">Is Licensed</h6>
                            </div>
                          </div>
                        </Col>

                        {isLicensed && (
                          <Col md={6} className="mt-3">
                            <Label>
                              License Number
                              {/* <span className="text-danger">*</span> */}
                            </Label>
                            <Input
                              name="licenseNumber"
                              value={values.licenseNumber}
                              onChange={handleChange}
                            />
                          </Col>
                        )}
                      </>
                    )}

                    {step === 3 && (
                      <>
                        <Col md={6} className="mb-3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom06">
                              Profile Image
                            </Label>
                            <Dropzone
                              onDrop={async acceptedFiles => {
                                acceptedFiles.map(file =>
                                  Object.assign(file, {
                                    preview: URL.createObjectURL(file),
                                    formattedSize: formatBytes(file.size),
                                  })
                                );
                                try {
                                  const res = await getImage({
                                    image: acceptedFiles,
                                  });

                                  if (res?.status === 413) {
                                    alert(
                                      "The uploaded image is too large. Please choose a file under 1MB."
                                    );
                                    return;
                                  }
                                  // If it returns JSON
                                  const data = await res;
                                  setProfileImg(data?.image);
                                } catch (err) {
                                  alert(
                                    "Image upload failed. Please try again."
                                  );
                                  console.error("Upload error:", err);
                                }
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone image_drop">
                                  <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="">
                                      <i className="display-6 text-muted bx bxs-cloud-upload" />
                                    </div>
                                    <h6>Click to upload profile image</h6>
                                  </div>
                                </div>
                              )}
                            </Dropzone>

                            <div
                              className="dropzone-previews mt-3"
                              id="file-previews"
                            >
                              {ProfileImg && (
                                <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <ProfileImage
                                          image={ProfileImg}
                                          height="80"
                                          classNames="avatar-sm rounded bg-light"
                                        />
                                      </Col>
                                      <Col>
                                        <Button
                                          color="danger"
                                          size="sm"
                                          onClick={() => setProfileImg(null)}
                                        >
                                          Remove
                                        </Button>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Label>
                            Status <span className="text-danger">*</span>
                          </Label>
                          <Select
                            options={statusList}
                            value={selectedStatus}
                            onChange={opt => {
                              setSelectedStatus(opt);
                              setFieldValue("status", opt.value);
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                  <div className="d-flex justify-content-end mt-4">
                    {step > 1 && (
                      <Button
                        className="me-2"
                        onClick={() => setStep(step - 1)}
                      >
                        Previous
                      </Button>
                    )}
                    {step < 3 && (
                      <Button color="primary" onClick={() => setStep(step + 1)}>
                        Next
                      </Button>
                    )}
                    {step === 3 && (
                      <Button color="primary btn btn-md px-4" type="submit">
                        Create
                      </Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
            {success_msg && (
              <SweetAlert
                success
                title="Success"
                onConfirm={() => {
                  setsuccess_msg(false);
                  toggle();
                }}
              >
                Doctor Profile Created Successfully!
              </SweetAlert>
            )}
            {error_msg && (
              <SweetAlert
                danger
                title="Error"
                onConfirm={() => seterror_msg(false)}
              >
                Something went wrong!
              </SweetAlert>
            )}
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateDoctor;
